import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";

declare var Keycloak: any;

@Injectable({
  providedIn: 'root'
})
export class KeycloakService {
  
  public keycloakAuth: any;

  constructor() { }

  async init(): Promise<any> {
    const config = {
      'url': environment.AUTH_RACINE_URL,
      'realm': environment.REALM,
      'clientId': environment.CLIENT_ID
    };

    this.keycloakAuth = new Keycloak(config);

    try {
      await this.keycloakAuth.init({ 
        onLoad: 'login-required',
        checkLoginIframe: false
       });
      return;
    } catch (error) {
      throw error;
    }
  }

  getToken(): string {
    let token = this.keycloakAuth.token;
    console.log(token);
    return token;
  }

  logout() : any {
    return this.keycloakAuth.logout();
  }

  getName(): string {
    return this.keycloakAuth.idTokenParsed.name;
  }

  getUsername(): string {
    return this.keycloakAuth.idTokenParsed.preferred_username;
  }

  getAccessPermissions(): string[] {
    return this.keycloakAuth.realmAccess.roles;
  }
}
